<template>
  <v-container>
    <div
      class="mt-5"
      :class="{'mx-10': $vuetify.breakpoint.lgAndUp}"
      style="border:1px solid black"
    >
      <v-tabs
        ref="tabs"
        v-model="active"
        align-with-title
        slider-color="white"
        show-arrows
      >
        <v-tab
          v-for="item in filteredTabItems"
          :key="item.name"
          class="divider font-black"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item
          v-if="$hasPermissionTo(['view education levels'])"
          class="pb-12"
        >
          <setup-education-level-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view education majors'])"
          class="pb-12"
        >
          <setup-education-major-container-view />
        </v-tab-item>

        <v-tab-item
          v-if="$hasPermissionTo(['view education institutes'])"
          class="pb-12"
        >
          <setup-education-institutes-container-view />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupEducationInstitutesContainerView: () => import('@/components/hris/setup/education/institutes/ContainerView'),
      SetupEducationLevelContainerView: () => import('@/components/hris/setup/education/level/ContainerView'),
      SetupEducationMajorContainerView: () => import('@/components/hris/setup/education/major/ContainerView'),
    },
    data () {
      return {
        tabItems: [ ],
        active: null,
      }
    },

    computed: {   
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view education levels'])) {
          modifiedTab.push({ name: 'Education Level' })
        }

        if (this.$hasPermissionTo(['view education majors'])) {
          modifiedTab.push({ name: 'Education Major' })
        }

        if (this.$hasPermissionTo(['view education institutes'])) {
          modifiedTab.push({ name: 'Education Institutes' })
        }

        return modifiedTab
      },
    },
  }
</script>

<style scoped>
.divider { 
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
} 

.font-black{
  color:black !important;
}

.divider.font-black.v-tab.v-tab--active{
  border-bottom:0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
